
export const setToken = (token) => localStorage.setItem("token", token);
export const getToken = () => localStorage.getItem("token");
export const clearToken = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
};

